import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialXStorageService = {
    options: async () => axios.get(`${API_URL}/material-x-storage/options/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    optionsByStorage: async (storage, withStorage = true) => {
        return axios.get(`${API_URL}/material-x-storage/options/storage/${storage}`)
            .then(({data}) => {
                if (withStorage) return data.map(d => ({value: d.id, label: d.text}))

                return data.map(d => ({value: d.id, label: d.text_without_storage}))
            }).catch((err) => { throw err })
    },
    optionsAvailableByGroupAndStorage: async (group, storage, withGroup = true) => {
        return axios.get(`${API_URL}/material-x-storage/options-available/all/${group}/${storage}`)
            .then(({data}) => {
                if (withGroup) return data.map(d => ({value: d.id, label: d.text, material_id: d.material_id}))
                return data.map(d => ({value: d.id, label: d.text_without_group, ...d}))
            }).catch((err) => { throw err })
    },
    optionsAvailableByStorage: async (storage) => axios.get(`${API_URL}/material-x-storage/options-available/storage/${storage}`).then(({data}) => data.map(d => ({value: d.id, label: d.text, ...d}))).catch((err) => { throw err }),
    optionsUniqueByGroupAndStorage: async (group, storage, withGroup = true) => {
        return axios.get(`${API_URL}/material-x-storage/options-unique/all/${group}/${storage}`)
            .then(({data}) => {
                if (withGroup) return data.map(d => ({value: d.id, label: d.text, ...d}))

                return data.map(d => ({value: d.id, label: d.text_without_group, ...d}))
            })
            .catch((err) => { throw err })
    },
    optionsByGroup: async (group) => axios.get(`${API_URL}/materials/options/all/${group}`).then(({data}) => data.map(d => ({value: d.id, label: d.text, material_id: d.material_id}))).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-x-storage/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getByKits: async (formData) => axios.post(`${API_URL}/material-x-storage/get/material-kit`, formData).then(({data}) => data).catch((err) => { throw err }),
    list: async () => axios.post(`${API_URL}/material-x-storage/list`).then(({data}) => data).catch((err) => { throw err }),
    updateQuantity: async (formData) => axios.post(`${API_URL}/material-x-storage/update-quantity`, formData).then(({data}) => data).catch((err) => { throw err }),
    updateBreakdown: async (formData) => axios.post(`${API_URL}/material-x-storage/update-breakdown`, formData).then(({data}) => data).catch((err) => { throw err }),
}

export default MaterialXStorageService;